import React from 'react';
import styled from 'styled-components';
import Footer from 'components/Footer';
import fonts from 'const/style/fonts';
import colors from 'const/style/colors';

export const Frame = styled.div` 
white-space:pre-line;
text-align:left;
margin:10px;
text-align: left;
font: 14px/23px NanumSquare;
letter-spacing: 0px;
color: #000000;

.main-html{
  margin-top:-10px;
}


.content-frame{
  display:flex;
  flex-direction:row;
  padding-left:10px;
  h2{
    font-weight:bold;
    display:inline-block;
  }
  .number{
    top:0px;
    h2{
      margin-top: -1.5px;
    }
    }
  }
  .content{
    margin-left:5px;
    .padding-top{
      padding-top:5px;
    }
  }
}

`;

export const PrivacyTermsStrForRegister = `
<div class='content-frame'>
<div class='number'><h2>①</h2></div>
<div class='content'><h2>처리하는 개인정보의 항목</h2>
회사의 JOBFLEX 온라인 PT (온라인 PT전형)는 전형 참여를 위한 개인정보 외에는 사이트 이용을 위해 필요한 최소한의 범위로 개인정보를 수집합니다.
<h2 class='padding-top'>[온라인 PT 전형 응시]</h2>
필수 l 이름, 인증코드, 응시영상, 전형과제(PDF) 
</div>
</div>
<div class='content-frame'>
<div class='number'><h2>②</h2></div>
<div class='content'><h2>개인정보의 처리 목적</h2>
정보주체의 개인정보에 대한 처리(수집, 이용 등) 목적은 다음과 같습니다. 
<div class='padding-top'> -	온라인 PT 전형 진행 및 결과 안내</div> 
</div>
</div>
<div class='content-frame'>
<div class='number'><h2>③</h2></div>
<div class='content'><h2>개인정보의 처리 및 보유 기간</h2>
1) 회사는 법령에 따른 개인정보 보유∙이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유∙이용기간 내에서 개인정보를 처리∙보유하며, 개인정보의 처리 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
2) 개인정보 처리 및 보유 기간은 다음과 같으며, 아래 각 항목에 대하여 정보주체가 명시적으로 파기 요청을 하는 경우 지체 없이 파기합니다. 
<div class='class='padding-top'>-	온라인 PT 응시 정보 : 채용절차가 완료되는 시점까지</div>

※ 단, 통신비밀보호법의 규정에 의하여 정보주체의 인터넷 로그기록 및 접속지 추적자료는 3개월간 별도 보관합니다.
</div>
</div>
<div class='content-frame'>
<div class='number'><h2>④</h2></div>
<div class='content'><h2>동의 거부와 불이익</h2>
필수동의 항목 : 정보주체는 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 
다만, 필수 항목의 수집 및 이용에 대해 동의하지 않을 경우에는 온라인 PT전형을 진행할 수 없습니다.
</div>
</div>
`;


const JobFlexPrivacyTerms = () => (
      <Frame>
          <div className='main-html' dangerouslySetInnerHTML={{ __html: PrivacyTermsStrForRegister }} />
      </Frame>
);

export default JobFlexPrivacyTerms;
